<template>
  <loading-page v-if="fetchingOutputPreset || fetchingEmptyOutputPreset" />
  <output-preset-form
    v-else
    :submit-loading="creatingOutputPreset"
    :duplicating="duplicating"
    @submit="createOutputPreset"
  />
</template>

<script>
import { mapGetters } from 'vuex'
import OutputPresetForm from './OutputPresetForm.vue'
import redirectError from '@/services/redirectError'

export default {
  name: 'CreateOutputPreset',
  components: { OutputPresetForm },
  data() {
    return {
      duplicating: false,
    }
  },
  computed: {
    ...mapGetters('outputPresets', [
      'fetchingEmptyOutputPreset',
      'fetchingOutputPreset',
    ]),
    creatingOutputPreset() {
      return this.$store.state.outputPresets.creatingOutputPreset
    },
  },
  created() {
    if (this.$route.params.presetId) {
      this.getPreset()
    } else {
      this.$store.commit('outputPresets/SET_FETCHING_OUTPUT_PRESET', false)
    }
    this.getEmptyPreset()
  },
  methods: {
    getEmptyPreset() {
      this.$store
        .dispatch('outputPresets/getEmptyOutputPreset')
        .catch(err => redirectError(err, this.$router, this.$route.path))
    },
    getPreset() {
      this.duplicating = true
      this.$store
        .dispatch(
          'outputPresets/getOutputPresetById',
          this.$route.params.presetId,
        )
        .catch(err => redirectError(err, this.$router, this.$route.path))
    },
    createOutputPreset(e) {
      this.$store
        .dispatch('outputPresets/createOutputPreset', e)
        .then(() => {
          this.$router.push({
            name: this.$route.params.from || 'output-presets',
            params: {
              toast: {
                title: 'Success',
                variant: 'success',
                message: 'Output preset created successfully',
              },
              backFromOutputPresets: true,
              activeTab: this.$route.params.activeTab,
            },
            query: this.$route.query,
          })
        })
        .catch(error => {
          this.errorToast(
            error.response?.data?.errors[0] || 'An error occurred',
          )
        })
    },
  },
}
</script>
